import {
  DoughnutChartConfig,
  LineChartConfig,
  StackBarChartConfig,
} from '../interfaces/chart-data.interface';

//Doughnut Chart Defaults

export const DEFAULT_DOUGHNUT_CONFIG: DoughnutChartConfig = {
  DOUGHNUT: {
    innerRadius: '70%',
    outerRadius: '100%',
    legendPosition: 'bottom' as const,
    fontSize: 12,
    fontWeight: 'normal',
    textColor: '#475467',
    colors: ['#7CD4FD', '#47CD89', '#9B8AFB'],
  },
  DOUGHNUT_LEGEND_STYLES: {
    bottom: '1%',
    right: 'center',
    left: 'center',
    orient: 'horizontal',
    icon: 'circle',
    itemWidth: 8,
    itemHeight: 8,
    textStyle: {
      fontSize: 14,
      fontWeight: 'bold',
      color: '#475467',
    },
  },
};

//Stack Bar Chart Defaults

export const STACK_BAR_COLORS = {
  primary: '#128E55',
  secondary: '#43C187',
  tertiary: '#EAECF0',
  hover: '#e2eaf9',
};

export const DEFAULT_STACK_BAR_CONFIG: StackBarChartConfig = {
  colors: [
    STACK_BAR_COLORS.primary,
    STACK_BAR_COLORS.secondary,
    STACK_BAR_COLORS.tertiary,
  ],
  title: 'Stack Bar Chart',
  legendPosition: 'top',
  stack: 'stacked',
  xAxisData: [],
};

export const STACK_BAR_AXIS_STYLES = {
  axisTick: {
    show: false,
  },
  axisLine: {
    show: false,
  },
  splitLine: {
    lineStyle: {
      color: '#EAECF0',
    },
  },
};

//Line Chart Defaults

export const LINE_CHART_COLORS = {
  PRIMARY: '#17B26A',
  SECONDARY: '#6FD0A3',
  TERTIARY: '#128E55',
  AXIS_TEXT: '#475467',
  GRID_LINE: '#EAECF0',
} as const;

export const DEFAULT_LINE_CHART_CONFIG: LineChartConfig = {
  grid: {
    top: '15%',
    right: '3%',
    bottom: '15%',
    left: '3%',
    containLabel: true,
  },
  xAxisData: [],
  yAxisMin: 0,
  yAxisMax: 100,
  yAxisInterval: 20,
} as const;

export const LINE_CHART_AXIS_STYLES = {
  axisTick: {
    show: false,
  },
  axisLine: {
    show: false,
  },
  splitLine: {
    lineStyle: {
      color: LINE_CHART_COLORS.GRID_LINE,
    },
  },
} as const;
